import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app';
import session from './modules/session';
import account from './modules/account';
import user from './modules/user';
import role from './modules/role';
import tenant from './modules/tenant';
import city from './modules/city';
import district from './modules/district';
import customer from './modules/customer';
import packageType from './modules/packageType';
import smsSetting from './modules/smsSetting';
import emailSetting from './modules/emailSetting';
import paymentSetting from './modules/paymentSetting';
import mapSetting from './modules/mapSetting';
import agency from './modules/agency';
import airport from './modules/airport';
import flight from './modules/flight';
import currency from './modules/currency';
import payment from './modules/payment';
import auxService from './modules/auxService';

const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    city,
    district,
    customer,
    packageType,
    smsSetting,
    emailSetting,
    paymentSetting,
    mapSetting,
    agency,
    airport,
    flight,
    currency,
    payment,
    auxService
  },
});

export default store;
